import { render, staticRenderFns } from "./table-paginator.vue?vue&type=template&id=a0057c46"
import script from "./table-paginator.vue?vue&type=script&lang=js"
export * from "./table-paginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports